import BaseService from '@root/core/class/BaseService';

class inventoryService extends BaseService {
  public postDownExcelSell = (
    fromDt?: any,
    toDt?: string,
    state?: string,
    input?: string,
    sort?: boolean
  ) => {
    // return this.post('/sellers/export', {}, { responseType: 'blob' });
    return this.post(
      `/sellers/export?${Boolean(state) ? '&searchBy=' + state : '&searchBy='}${
        Boolean(input) ? '&search=' + input : '&search='
      }${Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='}${
        Boolean(toDt) ? '&toDt=' + toDt : '&toDt='
      }${Boolean(sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'}`,
      {},
      { responseType: 'blob' }
    );
  };

  public postDownExcelSellId = (body: Record<string, any>) => {
    return this.post('/sellers/export', body, {
      responseType: 'blob'
    });
  };

  public postDownExcelInven = (
    idSellName: number,
    fromDt?: any,
    toDt?: string,
    state?: string,
    input?: string,
    sort?: boolean
  ) => {
    // return this.post(
    //   `/sellers/${idSellName}/inventories/export`,
    //   {},
    //   { responseType: 'blob' }
    // );
    return this.post(
      `/sellers/${idSellName}/inventories/export?${
        Boolean(state) ? '&searchBy=' + state : '&searchBy='
      }${Boolean(input) ? '&search=' + input : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'
      }`,
      {},
      { responseType: 'blob' }
    );
  };

  public postDownExcelInvenId = (
    idSellName: number,
    body: Record<string, any>
  ) => {
    return this.post(`/sellers/${idSellName}/inventories/export`, body, {
      responseType: 'blob'
    });
  };

  public getDetailSell = (idSellName: number) => {
    return this.get(`/sellers/${idSellName}`, {});
  };

  public getListTableStock = (idSellName: number) => {
    return this.get(`/sellers/${idSellName}/inventories`);
  };

  public getInventoryDetail = (idSellName: number, inventoryId: number) => {
    return this.get(`/sellers/${idSellName}/inventories/${inventoryId}`);
  };

  public getOrderList = (idSellName: number, inventoryId: number) => {
    return this.get(`/sellers/${idSellName}/inventories/${inventoryId}/orders`);
  };

  public upDateLocation = (
    idSellName: number,
    inventoryId: number,
    body: Record<string, any>
  ) => {
    return this.put(`/sellers/${idSellName}/inventories/${inventoryId}`, body);
  };

  public getListSeller = (
    page: number,
    fromDt?: any,
    toDt?: string,
    state?: string,
    searchBy?: string,
    input?: string,
    sort?: boolean
  ) => {
    let inputUse = !!input
      ? input.replaceAll('%', '%25').replaceAll('#', '%23')
      : '';
    return this.get(
      `/sellers?page=${page}&limit=10${
        Boolean(state) ? '&searchBy=' + state : '&searchBy='
      }${Boolean(inputUse) ? '&search=' + inputUse : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'
      }`
    );
  };
  public getDetailTable = (
    idSellName: number,
    page: number,
    fromDt?: string,
    toDt?: string,
    state?: string,
    searchBy?: string,
    input?: string,
    sort?: boolean
  ) => {
    let inputUse = !!input
      ? input.replaceAll('%', '%25').replaceAll('#', '%23')
      : '';
    return this.get(
      `/sellers/${idSellName}/inventories?page=${page}&limit=10${
        Boolean(state) ? '&searchBy=' + state : '&searchBy='
      }${Boolean(inputUse) ? '&search=' + inputUse : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'
      }`
    );
  };
  public getDetailTableOrder = (
    idSellName: number,
    inventoryId: number,
    productId: number,
    page: number,
    sort?: boolean
  ) => {
    return this.get(
      `/sellers/${idSellName}/inventories/${inventoryId}/orders/${productId}?page=${page}&limit=10${
        Boolean(sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'
      }`
    );
  };
}
export default new inventoryService('/api/v1/warehouse', true);
